import { useCrowdfundingProvider } from '#Context/crowdfunding/Crowdfunding.provider.js';
import { CampaignPeerInfoCard } from '#crowdfunding/components/index.js';
import {
  useListCampaignPeers,
  useShowConsumerCampaignById,
  useShowConsumerCampaignSettingsById,
} from '@givebacks/api/store';
import { useNavigate } from 'react-router-dom';
import { ButtonMantine, Center, Grid, Stack, Title, TransitionElement } from 'ui';

export const Participants = () => {
  const navigate = useNavigate();
  const { causeId, campaignId } = useCrowdfundingProvider();
  const { data: campaign } = useShowConsumerCampaignById({ causeId, campaignId });
  const { data: campaignSettings } = useShowConsumerCampaignSettingsById({
    causeId,
    campaignId,
  });
  const { data: peerResponse } = useListCampaignPeers({
    campaignId: campaign?.uuid,
    causeId: campaign?.cause_id,
    peer_type: 'participants',
    queryOptions: {
      options: {
        credits: true,
      },
      order: {
        field: 'rank',
        direction: 'asc',
      },
    },
  });
  if (!campaignSettings?.isParticipantsEnabled || !peerResponse?.participants) return null;
  const { participants } = peerResponse;

  return (
    <TransitionElement mounted={!!participants?.length} transition={'fade'} duration={50}>
      <Stack maw={{ base: '100%', md: 684 }}>
        <Title order={2} style={{ textTransform: 'capitalize' }}>
          {campaign?.participant_options.convention_plural}
        </Title>
        <Grid>
          {participants
            ?.filter?.((_, index) => index < 3)
            ?.map((participant) => {
              return (
                <Grid.Col
                  span={{ base: 12, md: 4 }}
                  key={participant.uuid}
                  onClick={() => navigate(`participants/${participant.uuid}`)}
                >
                  <CampaignPeerInfoCard
                    peer_id={participant.uuid}
                    type="participants"
                    causeId={campaign?.cause_id}
                    campaignId={campaign?.uuid}
                  />
                </Grid.Col>
              );
            })}
        </Grid>
        {participants?.length && participants?.length > 3 && (
          <Center w="100%">
            <ButtonMantine size="sm" w={122} onClick={() => navigate('participants')}>
              View All
            </ButtonMantine>
          </Center>
        )}
      </Stack>
    </TransitionElement>
  );
};
